<div class="nav-bar">
  <div class="nav-bar-brand">
    <img
      [src]="logo().src || defaultLogoSrc"
      class="measured-logo act-as-link"
      [attr.alt]="logo().alt || 'Measured'"
      (click)="onLogoClick()" />
    @if (brandPicker(); as brandPicker) {
      <span class="brand-divider" aria-hidden="true"></span>
      <m-brand-picker
        [label]="brandPicker.label"
        [brands]="brandPicker.brands"
        [recentBrands]="brandPicker.recentBrands || []"
        [disabled]="!!brandPicker.disabled"
        [ariaLabel]="brandPicker.ariaLabel || 'Change brand'"
        (brandSelected)="onBrandSelected($event)"
        (panelShow)="brandPickerOpened.emit()">
      </m-brand-picker>
    }
  </div>

  <div class="nav-bar-menu">
    <div class="menu-group menu-group-primary">
      @for (action of primaryActions(); track action.id) {
        <ng-container
          *ngTemplateOutlet="
            actionTpl;
            context: { $implicit: action }
          "></ng-container>
      }
    </div>
  </div>

  <div class="nav-bar-right">
    <div class="menu-group menu-group-secondary">
      @for (action of secondaryActions(); track action.id) {
        <ng-container
          *ngTemplateOutlet="
            actionTpl;
            context: { $implicit: action }
          "></ng-container>
      }
    </div>

    @if (trailingAction(); as trailingAction) {
      <ng-container
        *ngTemplateOutlet="
          actionTpl;
          context: { $implicit: trailingAction }
        "></ng-container>
    }

    @if (avatar(); as avatar) {
      <m-mega-menu
        [trigger]="{ ariaLabel: avatar.ariaLabel || 'User menu' }"
        [items]="avatar.megaMenuItems || []"
        [columns]="1"
        [hideArrow]="true">
        <span
          class="avatar-initials"
          [style.background-color]="avatar.bg"
          [style.color]="avatar.color"
          >{{ avatar.initials }}</span
        >
      </m-mega-menu>
    }

    @if (postAvatarAction(); as postAvatarAction) {
      <ng-container
        *ngTemplateOutlet="
          actionTpl;
          context: { $implicit: postAvatarAction }
        "></ng-container>
    }
  </div>
</div>

<ng-template #actionTpl let-action>
  @if (hasMegaMenu(action)) {
    <m-mega-menu
      [trigger]="{
        label: action.label,
        iconName: action.iconName,
        ariaLabel: action.ariaLabel || action.label,
      }"
      [items]="action.megaMenuItems"
      [columns]="action.megaMenuColumns || 1"
      [hideArrow]="!!action.hideArrow"
      [active]="!!action.active"
      [disabled]="!!action.disabled"
      [showDot]="hasMegaMenuBadge(action)">
    </m-mega-menu>
  } @else if (hasMenu(action)) {
    <p-menu
      #actionMenu
      mHideOnWindowScroll
      [model]="action.menuItems"
      [popup]="true"
      appendTo="body"
      (onShow)="openMenuActionId.set(action.id)"
      (onHide)="openMenuActionId.set(null)"></p-menu>
    <m-nav-trigger
      [open]="openMenuActionId() === action.id"
      [class]="action.styleClass || ''"
      [disabled]="!!action.disabled"
      [ariaLabel]="action.ariaLabel || action.label || undefined"
      [ariaHaspopup]="true"
      [ariaExpanded]="openMenuActionId() === action.id"
      (clicked)="actionMenu.toggle($event)">
      <ng-container
        *ngTemplateOutlet="
          actionContentTpl;
          context: { $implicit: action }
        "></ng-container>
      @if (!action.hideArrow) {
        <em aria-hidden="true" class="material-symbols-outlined icon-small"
          >keyboard_arrow_down</em
        >
      }
    </m-nav-trigger>
  } @else {
    <m-nav-trigger
      [active]="!!action.active"
      [open]="!!action.open"
      [class]="action.styleClass || ''"
      [disabled]="!!action.disabled"
      [routerLink]="action.routerLink"
      [queryParams]="action.queryParams"
      [ariaLabel]="action.ariaLabel || action.label || undefined"
      (clicked)="onActionClick(action, $event)">
      <ng-container
        *ngTemplateOutlet="
          actionContentTpl;
          context: { $implicit: action }
        "></ng-container>
    </m-nav-trigger>
  }
</ng-template>

<ng-template #actionContentTpl let-action>
  <span class="action-content">
    @if (action.iconSrc) {
      <img
        [src]="action.iconSrc"
        alt=""
        aria-hidden="true"
        class="action-icon-img" />
    } @else if (action.iconName) {
      <em aria-hidden="true" class="material-symbols-outlined icon-regular">{{
        action.iconName
      }}</em>
    }
    @if (action.label) {
      <span class="b2 button-label">{{ action.label }}</span>
    }
    @if (action.badge) {
      <m-badge [label]="action.badge.label"></m-badge>
    }
    @if (action.notification && showNotificationDot(action.notification)) {
      <span class="notification-dot" aria-hidden="true"></span>
    }
  </span>
</ng-template>
